import TargetMenuModal from 'components/TargetMenuModal';
import { CommonResponse, TargetMenu } from 'models';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { TARGET_MENU_OVERLAY_FUNCTION } from 'utils';
import service from '../../overlayService';

interface AddMenuOverlayButtonProps {
  overlayGroupId: number;
  overlayGroupName: string;
}

function AddMenuOverlayButton({ overlayGroupId, overlayGroupName }: AddMenuOverlayButtonProps) {
  const { t } = useTranslation();

  // states
  const [isOpenTargetMenuModal, setIsOpenTargetMenuModal] = useState(false);

  // events
  function handleOpenOverlayMenuModal() {
    setIsOpenTargetMenuModal(true);
  }

  function handleCloseOverlayMenuModal() {
    setIsOpenTargetMenuModal(false);
  }

  function handleLoadData(): Promise<CommonResponse<TargetMenu[]>> {
    return service.listMenus(overlayGroupId);
  }

  function handleAdd(menuIds: number[]): Promise<CommonResponse<any>> {
    // compose add payload with overlayGroupId
    return service.addMenus(overlayGroupId, menuIds);
  }

  function handleDelete(menuIds: number[]): Promise<CommonResponse<any>> {
    // compose delete payload with overlayGroupId
    return service.deleteMenus(overlayGroupId, menuIds);
  }

  return (
    <>
      <Button onClick={handleOpenOverlayMenuModal}>{t('OverlayFunction.Button.target_menu')}</Button>
      {isOpenTargetMenuModal &&
        createPortal(
          <TargetMenuModal
            targetSourceType={TARGET_MENU_OVERLAY_FUNCTION}
            targetName={overlayGroupName}
            onLoadData={handleLoadData}
            onAdd={handleAdd}
            onDelete={handleDelete}
            onClose={handleCloseOverlayMenuModal}
          />,
          document.body
        )}
    </>
  );
}

export default AddMenuOverlayButton;
